import { Component } from '@angular/core';

@Component({
  selector: 'bu-level',
  template: `
  <nav class="level">
    <ng-content></ng-content>
  </nav>`
})
export class BuLevelComponent {}
